var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CompanyAvatar } from "@vividtheory/minerva-lab";
import { getIn, useFormikContext } from "formik";
import React from "react";
import { UploadSingleImageWithAvatar, } from "./UploadSingleImageWithAvatar";
import { UserAvatar } from "./UserAvatar";
export const FormikUploadSingleImageWithAvatar = (_a) => {
    var { name, imageType, edit } = _a, props = __rest(_a, ["name", "imageType", "edit"]);
    const formik = useFormikContext();
    const _value = getIn(formik.values, name);
    const values = formik.values;
    return edit ? (React.createElement(UploadSingleImageWithAvatar, Object.assign({ imageType: imageType, avatar: {
            src: _value,
            alt: imageType === "user"
                ? (values === null || values === void 0 ? void 0 : values.firstName)
                    ? `${values === null || values === void 0 ? void 0 : values.firstName} ${values === null || values === void 0 ? void 0 : values.lastName}`
                    : undefined
                : values.name,
        }, onImageChange: (url) => formik.setFieldValue(name, url) }, props))) : imageType === "user" ? (React.createElement(UserAvatar, { src: _value, alt: `${values.firstName} ${values.lastName}`, size: "lg", color: "surface" })) : (React.createElement(CompanyAvatar, { src: _value, alt: values.name, size: "lg", color: "surface" }));
};
//# sourceMappingURL=FormikUploadSingleImageWithAvatar.js.map